(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pdp-accordions] .pdp-acc__head').forEach(function (head) {
      head.addEventListener('click', function () {
        var acc = head.closest('.pdp-acc');
        var open = acc.classList.toggle('open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();

  // Move PDF manual links (e.g. User Guide, Safety Instructions) out of the description and into
  // the Manuals dropdown. If nothing is found, remove the now-empty Manuals accordion.
  (function () {
    var ul = document.querySelector('[data-pdp-manuals]');
    if (!ul) return;
    var descBody = document.querySelector('[data-pdp-accordions] .description-panel');
    if (descBody) {
      var icon = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/><path d="M12 12v5M9.5 14.5 12 17l2.5-2.5"/></svg>';
      Array.prototype.slice.call(descBody.querySelectorAll('a')).forEach(function (a) {
        if ((a.getAttribute('href') || '').toLowerCase().indexOf('.pdf') === -1) return;
        var name = (a.textContent || '').replace(/\s+/g, ' ').trim() || 'Download';
        var li = document.createElement('li');
        li.innerHTML = '<a href="' + a.href + '" target="_blank" rel="noopener" download>' + icon + '<span>' + name + '</span></a>';
        ul.appendChild(li);
        var p = a.closest('p');
        if (p && p.textContent.replace(/\s+/g, ' ').trim() === name) { p.remove(); } else { a.remove(); }
      });
    }
    if (!ul.children.length) { var acc = ul.closest('.pdp-acc'); if (acc) { acc.remove(); } }
  })();

  } catch(e) { console.error(e); }
})();
})();
